import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from '../../../components/Icon';
import { REPORT_STATUS, REPORT_STATUS_ICON } from '../../../constants/api';
export const ToolInfo = ({ id, status, tool, language, toolVersion, title }) => {
    const showToolInfo = language || toolVersion;
    return _jsxs("div", { children: [_jsx(Icon, { name: REPORT_STATUS_ICON[status], spin: status === REPORT_STATUS.PROCESSING, fixedWidth: true, className: 'mr-1', title: title }), _jsx("strong", { children: tool }), "\u00A0", _jsx("small", { children: showToolInfo
                    ? `${toolVersion ? `${toolVersion}` : ''} ${language ? `(${language})` : ''}`
                    : '' })] }, id);
};
